import { SearchQueryModelConverter } from '@neptune/search-query-domain';
import { LeaderboardView } from '@neptune/shared/lb-views-domain';
import {
  defaultVisibleColumnsSettings,
  RunsLineage,
  STANDARD_SORTING_OPTIONS,
} from '@neptune/shared/leaderboard-domain';
import { NameSearchMode } from '@neptune/shared/search-domain';

import { KnownAttributes } from 'domain/experiment/attribute';
import { LeaderboardViewType } from 'state/project-leaderboard/lb-views/types';

export const standardView: LeaderboardView = {
  id: 'standard-view',
  name: 'All runs',
  nameSearchQuery: '',
  nameSearchMode: NameSearchMode.REGEX,
  columnList: defaultVisibleColumnsSettings,
  defaultView: false,
  sortOptions: STANDARD_SORTING_OPTIONS,
  experimentsOnly: true,
  runsLineage: RunsLineage.FULL,
  isArchived: false,
  showSelectedHiddenByFilter: false,
};

export const archivedView: LeaderboardView = {
  id: 'archived-view',
  name: 'Archived runs',
  nameSearchQuery: '',
  nameSearchMode: NameSearchMode.REGEX,
  columnList: defaultVisibleColumnsSettings,
  defaultView: false,
  sortOptions: STANDARD_SORTING_OPTIONS,
  experimentsOnly: true,
  runsLineage: RunsLineage.FULL,
  isArchived: true,
  showSelectedHiddenByFilter: false,
};

export const myRunsViewId = 'my-runs-view';

export function createMyRunsView(username: string): LeaderboardView {
  return {
    ...standardView,
    id: myRunsViewId,
    name: 'My runs',
    query: SearchQueryModelConverter.convertSearchQueryToNql({
      criteria: [
        {
          attribute: KnownAttributes.Owner,
          operator: 'oneOf',
          type: 'owner',
          value: [username],
        },
      ],
      operator: 'and',
    }),
  };
}

export const builtInViewIds = [standardView.id, myRunsViewId, archivedView.id];
export const defaultViewIds = [standardView.id, archivedView.id];

export function getViewType(lbViewId: string): LeaderboardViewType {
  if ([standardView.id, myRunsViewId].includes(lbViewId)) {
    return 'standard';
  }

  if (lbViewId === archivedView.id) {
    return 'archived';
  }

  return 'custom';
}
